if (!customElements.get('lm-footer-links')) {
  customElements.define('lm-footer-links', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.media = window.matchMedia('(min-width: 750px)');
      this.update = () => { this.details.open = this.media.matches; };
      this.keepOpen = event => { if (this.media.matches) event.preventDefault(); };
      this.update();
      this.media.addEventListener('change', this.update);
      this.summary.addEventListener('click', this.keepOpen);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.update);
      this.summary?.removeEventListener('click', this.keepOpen);
    }
  });
}
